import { ScreenNamesInterface } from './types';

export enum ScreenNameEnums {
  HOME,
}

export const ScreenNames: ScreenNamesInterface = {
  HOME: 'Dashboard',
};
